module.exports = __webpack_public_path__ + "static/img/图片3.865428d5.png";